

const validateGiftItems = async () => {
  const giftItems = {}

  giftRules.map(rule => { giftItems[rule.variant_y_id] = 0 })

  const cartItems = await fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(resp => resp.items)

  const eligibleCartItems = cartItems.filter(item => {
    const variantIds = giftRules.map(e => +e.variant_x_id)
    return variantIds.includes(item.variant_id)
  })

  eligibleCartItems.map(item => {
    const giftRule = giftRules.find(rule => +rule.variant_x_id === item.variant_id)
    const giftCount = Math.floor(item.quantity / giftRule.quantity_x) * giftRule.quantity_y

    giftItems[giftRule.variant_y_id] += giftCount
    giftItems[giftRule.variant_y_id] = Math.min(giftItems[giftRule.variant_y_id], giftRule.variant_y_inventory)
  })

  const payload = Object.keys(giftItems).map(variant_y_id => {
    const desiredQuantity = giftItems[variant_y_id]
    const itemInCart = cartItems.find(e => +e.variant_id === +variant_y_id && e.properties?._buyxgety)
    const difference = desiredQuantity - (itemInCart?.quantity || 0)

    return Object.assign({},
      itemInCart && difference !== 0 ? {
        id: itemInCart.key,
        quantity: Math.max(desiredQuantity, 0),
        mode: 'update'
      } : {},
      !itemInCart && difference > 0 ? {
        id: variant_y_id,
        quantity: difference,
        mode: 'add'
      } : {}
    )
  }).filter(item => typeof item.id !== 'undefined')
  
  if (payload.length === 0) return;

  const itemsToUpdate = payload.filter(item => item.mode === 'update')
  const itemsToAdd = payload.filter(item => item.mode === 'add')

  if (itemsToUpdate.length > 0) {
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: itemsToUpdate.reduce((a, b) => ({ [b.id]: b.quantity }), {}) })
    })
  }

  if (itemsToAdd.length > 0) {
    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: itemsToAdd.map(item => ({
          id: item.id,
          quantity: item.quantity,
          properties: {
            _buyxgety: true
          }
        }))
      })
    })
  }

  const pageHtml = await fetch(window.location.href).then(res => res.text())
  const parser = new DOMParser();
  const html = parser.parseFromString(pageHtml, 'text/html')
  const gwpModal = document.querySelector('.gwp-modal')

  if (document.querySelector('.mini-cart__content')) document.querySelector('.mini-cart__content').innerHTML = html.querySelector('.mini-cart__content').innerHTML;
  if (document.querySelector('#cart-icon-bubble') && html.querySelector('#cart-icon-bubble')) document.querySelector('#cart-icon-bubble').innerHTML = html.querySelector('#cart-icon-bubble').innerHTML;
  if (document.querySelector('#cart') && html.querySelector('#cart')) document.querySelector('#cart').innerHTML = html.querySelector('#cart').innerHTML;

  if (gwpModal && gwpModal.hasAttribute('open')) {
    document.querySelector('.gwp-modal').setAttribute('open', true)
    document.querySelector('.gwp-modal').innerHTML = gwpModal.innerHTML
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  document.dispatchEvent(new CustomEvent('cart:loading'))
  await validateGiftItems()
  document.dispatchEvent(new CustomEvent('cart:loaded'))
})

document.addEventListener('cart-updated', async e => {
  document.dispatchEvent(new CustomEvent('cart:loading'))
  await validateGiftItems()
  document.dispatchEvent(new CustomEvent('cart:loaded'))
})
